'use client';
import React from 'react';
import { GradientText, Title, Container, Description } from './style';
import { PrismicRichText } from '@prismicio/react';

const TitleDescription = ({
  title,
  asTitle = 'h1',
  description,
  descriptionCenter,
  descriptionColor,
}) => {
  return (
    <Container>
      <Title as={asTitle}>
        <GradientText>{title}</GradientText>
      </Title>
      {description ? (
        <Description
          textCenter={descriptionCenter}
          style={{ color: descriptionColor }}
        >
          <PrismicRichText field={description} />
        </Description>
      ) : null}
    </Container>
  );
};

export default TitleDescription;
